export default "__VITE_ASSET__25908a71__"